class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('#cart-drawer-dialog');
    this.bindEvents();
  }

  open() {
    if (this.dialog && !this.dialog.open) this.dialog.showModal();
  }

  close() {
    this.dialog?.close();
  }

  bindEvents() {
    this.querySelector('[data-cart-close]')?.addEventListener('click', () => this.close());

    this.dialog?.addEventListener('click', (e) => {
      if (e.target === this.dialog) {
        this.close();
        return;
      }
      this.onClick(e);
    });
  }

  onClick(e) {
    if (e.target.closest('[data-cart-continue-shopping]')) {
      this.close();
      return;
    }

    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      this.changeQty(qtyBtn.dataset.line, parseInt(qtyBtn.dataset.qtyChange, 10));
      return;
    }

    const removeBtn = e.target.closest('[data-remove-item]');
    if (removeBtn) {
      e.preventDefault();
      this.setLineQty(removeBtn.dataset.line, 0);
      return;
    }

    if (e.target.closest('[data-remove-coupon]')) {
      e.preventDefault();
      this.removeCoupon();
      return;
    }

    if (e.target.closest('[data-cart-clear]')) {
      e.preventDefault();
      this.clearCart();
    }
  }

  async changeQty(line, delta) {
    const display = this.querySelector(`[data-qty-display="${line}"]`);
    const current = display ? parseInt(display.textContent, 10) : 1;
    await this.setLineQty(line, Math.max(0, current + delta));
  }

  async removeCoupon() {
    if (this.loading) return;
    this.setLoading(true);
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: '',
          sections: 'cart-drawer',
          sections_url: window.location.pathname,
        }),
      });
      await this.refresh();
      document.querySelector('cart-page')?.refresh?.();
    } finally {
      this.setLoading(false);
    }
  }

  async clearCart() {
    if (this.loading) return;
    this.setLoading(true);
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      await this.refresh();
      document.querySelector('cart-page')?.refresh?.();
    } finally {
      this.setLoading(false);
    }
  }

  async setLineQty(line, quantity) {
    if (this.loading) return;
    this.setLoading(true);

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity }),
      });

      await this.refresh();
      document.querySelector('cart-page')?.refresh?.();
    } finally {
      this.setLoading(false);
    }
  }

  async refresh() {
    const res = await fetch(`/?sections=cart-drawer&_=${Date.now()}`, { cache: 'no-store' });
    const data = await res.json();

    const parser = new DOMParser();
    const doc = parser.parseFromString(data['cart-drawer'], 'text/html');

    const newItems = doc.getElementById('cart-drawer-items');
    const currentItems = this.querySelector('#cart-drawer-items');
    if (newItems && currentItems) currentItems.replaceWith(newItems);

    const openTab = this.querySelector('cart-tabs')?.activeTab;
    const newFooter = doc.getElementById('cart-drawer-footer');
    const currentFooter = this.querySelector('#cart-drawer-footer');
    if (newFooter && currentFooter) currentFooter.replaceWith(newFooter);
    if (openTab) this.querySelector('cart-tabs')?.showTab(openTab);

    const newCount = doc.querySelector('cart-drawer')?.dataset.itemCount ?? '0';
    this.dataset.itemCount = newCount;
    this.syncHeaderCount(newCount);

    if (typeof runCurrencyConverter === 'function') {
      runCurrencyConverter();
    }
  }

  syncHeaderCount(count) {
    const badge = document.querySelector('[data-cart-count]');
    if (!badge) return;

    const n = parseInt(count, 10);
    badge.textContent = n > 0 ? n : '';
    badge.hidden = n === 0;
  }

  setLoading(state) {
    this.loading = state;
    this.toggleAttribute('data-loading', state);
  }
}

customElements.define('cart-drawer', CartDrawer);

document.addEventListener('click', (e) => {
  if (!e.target.closest('[data-cart-open]')) return;
  e.preventDefault();
  document.querySelector('cart-drawer')?.open();
});

document.addEventListener('cart-drawer:open', () => {
  document.querySelector('cart-drawer')?.open();
});
